import { createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h1", {
  class: "anchor fw-bolder mb-5",
  id: "overview"
}, [
  /*#__PURE__*/_createVNode("a", { href: "#example3" }),
  /*#__PURE__*/_createTextVNode(" Form-level Validation ")
], -1)
const _hoisted_3 = { class: "py-5" }
const _hoisted_4 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Instead of providing validations for each field individually which can clutter your code, you can instead define the validation schema using the "),
  /*#__PURE__*/_createVNode("b", null, "useForm"),
  /*#__PURE__*/_createTextVNode(" function by passing a "),
  /*#__PURE__*/_createVNode("b", null, "validationSchema"),
  /*#__PURE__*/_createTextVNode(" option. Each field will automatically be associated with it and will be validated accordingly. ")
], -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("p", null, " A simple validation schema can be an object containing field names as keys and validation functions as the value for those keys. ", -1)
const _hoisted_6 = { class: "rounded border p-10" }
const _hoisted_7 = { class: "mb-10" }
const _hoisted_8 = /*#__PURE__*/_createVNode("label", {
  for: "emailField",
  class: "form-label"
}, "Email address", -1)
const _hoisted_9 = { class: "text-danger" }
const _hoisted_10 = /*#__PURE__*/_createVNode("label", {
  for: "passwordField",
  class: "form-label"
}, "Password", -1)
const _hoisted_11 = { class: "text-danger" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CodeHighlighter2 = _resolveComponent("CodeHighlighter2")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _hoisted_4,
      _hoisted_5,
      _createVNode("div", _hoisted_6, [
        _createVNode("div", _hoisted_7, [
          _hoisted_8,
          _withDirectives(_createVNode("input", {
            type: "email",
            name: "email",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.email = $event)),
            class: "form-control form-control-solid",
            id: "emailField",
            placeholder: "email"
          }, null, 512), [
            [_vModelText, _ctx.email]
          ]),
          _createVNode("span", _hoisted_9, _toDisplayString(_ctx.emailError), 1)
        ]),
        _hoisted_10,
        _withDirectives(_createVNode("input", {
          type: "password",
          name: "password",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.password = $event)),
          class: "form-control form-control-solid",
          id: "passwordField",
          placeholder: "password"
        }, null, 512), [
          [_vModelText, _ctx.password]
        ]),
        _createVNode("span", _hoisted_11, _toDisplayString(_ctx.passwordError), 1),
        _createVNode(_component_CodeHighlighter2, null, {
          html: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.example3Html), 1)
          ]),
          js: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.example3Js), 1)
          ]),
          _: 1
        })
      ])
    ])
  ]))
}